import { trackingDefaults } from '../config/tracking.js';

/** Add attribution without changing the action or the catalog's base URLs. */
export function createTrackedUrl({ url, source, destination }, currentProductId) {
  const tracked = new URL(url);
  const placement = trackingDefaults.placements[source];
  const action = trackingDefaults.actions[source === 'product' ? 'app': destination];
  tracked.searchParams.set('utm_source', trackingDefaults.source);
  tracked.searchParams.set('utm_medium', trackingDefaults.medium);
  tracked.searchParams.set('utm_campaign', currentProductId ?? trackingDefaults.fallbackCampaign);
  tracked.searchParams.set('utm_content', `${placement}_${action}`);
  return tracked.href;
}
